(function () {
  const TOWER_GARDEN_PRODUCT_IDS = [
    8482658713830,
    8639835603174,
    8639836422374,
    8639835275494,
    8639837208806,
    8639835996390,
    8639836520678,
    8973658030310,
    9611886133478,
    9606259540198,
    9606257148134
  ];

  // Awtomic Build-a-Box "Pod Squad Subscription" (product 9861899944166).
  // The box contents come from the bundle's default preselection, which the
  // Awtomic app proxy serves publicly.
  const POD_SQUAD_BUNDLE_ID = 9861899944166;
  const POD_SQUAD_VARIANT_ID = 48375148118246;
  // "5 Months Free Pod Squad" plan: 100% off the first 5 orders, then full
  // price. The storefront widget hides this plan (awtomic-theme-custom), so
  // only this script uses it.
  const POD_SQUAD_SELLING_PLAN_ID = 7758119142;
  const POD_SQUAD_BUNDLE_API =
    '/tools/bundle-subscriptions/api/bundle/' + POD_SQUAD_BUNDLE_ID;

  // The "__" suffix makes this a private Shopify cart attribute.
  const POD_SQUAD_OPT_OUT_ATTRIBUTE = 'pod_squad_opted_out__';

  const originalFetch = window.fetch.bind(window);
  let isSyncing = false;

  function hasTowerGarden(cart) {
    return cart.items.some(item =>
      TOWER_GARDEN_PRODUCT_IDS.includes(Number(item.product_id))
    );
  }

  function hasPodSquad(cart) {
    return cart.items.some(item =>
      Number(item.variant_id) === POD_SQUAD_VARIANT_ID
    );
  }

  function numericId(gid) {
    return String(gid || '').split('/').pop();
  }

  let bundlePromise = null;

  function getBundleData() {
    if (!bundlePromise) {
      bundlePromise = originalFetch(POD_SQUAD_BUNDLE_API, {
        headers: { Accept: 'application/json' }
      })
        .then(response => {
          if (!response.ok) {
            throw new Error(`Unable to load Pod Squad bundle: ${response.status}`);
          }
          return response.json();
        })
        .catch(error => {
          bundlePromise = null; // allow a retry on the next cart change
          throw error;
        });
    }
    return bundlePromise;
  }

  // Builds the same cart line that the Awtomic Build-a-Box builder adds:
  // one line for the box variant, with the box contents in line properties.
  // The Awtomic backend reads _bundleProductId, _variantId, _bundleBoxSize
  // and the _pv_<variantId> quantities.
  async function buildPodSquadLine() {
    const data = await getBundleData();
    const bundle = data && data.bundle;
    if (!bundle) throw new Error('Pod Squad bundle data is missing');

    const settings = (bundle.Settings || []).find(
      s => numericId(s.VariantId) === String(POD_SQUAD_VARIANT_ID)
    );
    if (!settings) throw new Error('Pod Squad box size is missing');

    const preselections = bundle.Preselections || [];
    const preselection =
      preselections.find(p => p.Id === bundle.DefaultPreselectionId) ||
      preselections[0];
    if (!preselection || !preselection.Selections) {
      throw new Error('Pod Squad preselection is missing');
    }

    const sizeKey =
      Object.keys(preselection.Selections).find(
        key => numericId(key) === String(POD_SQUAD_VARIANT_ID)
      ) || Object.keys(preselection.Selections)[0];
    const selections = preselection.Selections[sizeKey] || {};

    // Product titles for the visible "<pod name>: qty" properties.
    const names = {};
    (data.productsInSections || []).forEach(section => {
      (section.products || []).forEach(product => {
        (product.Variants || []).forEach(variant => {
          names[numericId(variant.VariantId)] = product.Title;
        });
      });
    });

    const contents = {};
    let total = 0;
    Object.keys(selections).forEach(variantGid => {
      const quantity = Number(selections[variantGid]);
      if (!(quantity > 0)) return;
      const variantId = numericId(variantGid);
      contents[`_pv_${variantId}`] = quantity;
      if (names[variantId]) {
        contents[names[variantId].replace(/[&]/gi, 'and')] = `${quantity}`;
      }
      total += quantity;
    });

    const boxSize = Number(settings.Size);
    if (!total || (boxSize && total !== boxSize)) {
      throw new Error(
        `Pod Squad preselection has ${total} pods, box size is ${boxSize}`
      );
    }

    const sortedContents = {};
    Object.keys(contents)
      .sort()
      .forEach(key => {
        sortedContents[key] = contents[key];
      });

    return {
      id: POD_SQUAD_VARIANT_ID,
      quantity: 1,
      selling_plan: POD_SQUAD_SELLING_PLAN_ID,
      properties: Object.assign(
        {
          _bundleLabel: settings.Label,
          _bundleProductId: bundle.ProductId,
          _bundleName: bundle.Name,
          _bundleBoxSize: boxSize,
          _variantId: settings.VariantId,
          _bundleBoxPrice: Number(settings.Price)
        },
        sortedContents
      )
    };
  }

  function hasOptedOut(cart) {
    return cart.attributes?.[POD_SQUAD_OPT_OUT_ATTRIBUTE] === 'true';
  }

  async function getCart() {
    const response = await originalFetch('/cart.js');

    if (!response.ok) {
      throw new Error(`Unable to retrieve cart: ${response.status}`);
    }

    return response.json();
  }

  async function recordPodSquadOptOut() {
    const response = await originalFetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        attributes: {
          [POD_SQUAD_OPT_OUT_ATTRIBUTE]: 'true'
        }
      })
    });

    if (!response.ok) {
      throw new Error(`Unable to record Pod Squad opt-out: ${response.status}`);
    }
  }

  // Setting a cart attribute to null removes it from the cart.
  async function clearPodSquadOptOut() {
    const response = await originalFetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        attributes: {
          [POD_SQUAD_OPT_OUT_ATTRIBUTE]: null
        }
      })
    });

    if (!response.ok) {
      throw new Error(`Unable to clear Pod Squad opt-out: ${response.status}`);
    }
  }

  async function syncPodSquad(cart) {
    if (isSyncing) return;

    isSyncing = true;

    try {
      cart = cart || await getCart();

      if (
        hasTowerGarden(cart) &&
        !hasPodSquad(cart) &&
        !hasOptedOut(cart)
      ) {
        const podSquadLine = await buildPodSquadLine();

        const response = await originalFetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            items: [podSquadLine]
          })
        });

        if (!response.ok) {
          throw new Error(`Unable to add Pod Squad: ${response.status}`);
        }
      }
    } catch (error) {
      console.error('Pod Squad sync failed:', error);
    } finally {
      isSyncing = false;
    }
  }

  window.fetch = async function (...args) {
    const url =
      typeof args[0] === 'string'
        ? args[0]
        : args[0]?.url || '';

    const isCartMutation =
      url.includes('/cart/add') ||
      url.includes('/cart/change') ||
      url.includes('/cart/update') ||
      url.includes('/cart/clear');

    if (!isCartMutation) {
      return originalFetch(...args);
    }

    let cartBeforeMutation;

    try {
      cartBeforeMutation = await getCart();
    } catch (error) {
      console.warn('Could not inspect cart before mutation:', error);
    }

    const result = await originalFetch(...args);

    if (!result.ok) {
      return result;
    }

    try {
      let cartAfterMutation = await getCart();

      // A Pod Squad item existed before this cart action but no longer
      // exists afterward, so treat that removal as an intentional opt-out.
      const removedPodSquad =
        cartBeforeMutation &&
        hasPodSquad(cartBeforeMutation) &&
        !hasPodSquad(cartAfterMutation);

      // A Tower Garden was re-added after being absent from the cart, so
      // any earlier opt-out is stale and the free-pod offer should trigger
      // again for the new unit.
      const addedTowerGarden =
        cartBeforeMutation &&
        !hasTowerGarden(cartBeforeMutation) &&
        hasTowerGarden(cartAfterMutation);

      if (removedPodSquad) {
        await recordPodSquadOptOut();
      } else if (addedTowerGarden && hasOptedOut(cartAfterMutation)) {
        await clearPodSquadOptOut();
        cartAfterMutation = await getCart();
        await syncPodSquad(cartAfterMutation);
      } else {
        await syncPodSquad(cartAfterMutation);
      }
    } catch (error) {
      console.error('Pod Squad cart handling failed:', error);
    }

    return result;
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => syncPodSquad());
  } else {
    syncPodSquad();
  }
})();